import type { PaymentSubState } from '@diamond/shared/types';

export interface ResolveOrderDetailPaymentProofVisibilityArgs {
  isLegacyTransferred: boolean;
  isLegacyWaitingForPayment: boolean;
  isPaymentInstructionEnabled: boolean;
  paymentSubState: PaymentSubState | undefined;
}

export interface OrderDetailPaymentProofVisibility {
  hasTransferred: boolean;
  isWaitingForPayment: boolean;
  shouldShowPaymentProof: boolean;
}

/**
 * Resolves Order Detail Bukti Transfer section visibility.
 * Bukti show/hide follows main bank-transfer heuristics and is independent of
 * Payment Instruction FF / payment_sub_state. When Pay FF is on, sub_state only
 * drives waiting/transferred flow flags (countdown, Unggah CTA, scroll).
 */
export const resolveOrderDetailPaymentProofVisibility = ({
  isLegacyTransferred,
  isLegacyWaitingForPayment,
  isPaymentInstructionEnabled,
  paymentSubState,
}: ResolveOrderDetailPaymentProofVisibilityArgs): OrderDetailPaymentProofVisibility => {
  const shouldShowPaymentProof =
    isLegacyWaitingForPayment || isLegacyTransferred;

  if (!isPaymentInstructionEnabled) {
    return {
      hasTransferred: isLegacyTransferred,
      isWaitingForPayment: isLegacyWaitingForPayment,
      shouldShowPaymentProof,
    };
  }

  const isWaitingForPayment =
    paymentSubState === 'instruction' || paymentSubState === 'proof_draft';
  const hasTransferred =
    paymentSubState === 'proof_draft' || paymentSubState === 'done'
      ? true
      : isLegacyTransferred;

  return {
    hasTransferred,
    isWaitingForPayment,
    shouldShowPaymentProof,
  };
};
